import { ROUTES } from "@/config/types";
import { setNavigation } from "@/store/slices/appSlice";
import { store } from "@/store/store";
import { useEffect, useState } from "react"
import logo from '../assets/images/logo.png';

export const handlePageChange = () => {
    window.scroll({
        top: 0,
        behavior: "smooth",
    });
}

export const Navigation = () => {

    const [toggleNavbar, setToggleNavbar] = useState(false)

    const [isBurgerOpen, setIsBurgerOpen] = useState(false)
    const toggleNavbarHandler = () => {
        const scrolled = window.scrollY

        if (scrolled > 60) {
            setToggleNavbar(true);
        } else if (scrolled <= 60) {
            setToggleNavbar(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleNavbarHandler, true);

        // Remove the event listener
        return () => {
            window.removeEventListener('scroll', toggleNavbarHandler, true);
        };
    }, []);



    return (
        <>
            <div className={`mobile-menu ${isBurgerOpen ? ' open ' : ''}`} >
                <div className="menu-wrapper  flex-column d-flex h-100 align-items-start align-items-sm-center justify-content-start justify-content-sm-center">
                    <div className="text-white fw-bold fs-30 my-3 pointer " onClick={(e) => {
                        store.dispatch(setNavigation(ROUTES.HOME))
                        setIsBurgerOpen(false)
                    }}>Home</div>

                    <div className="text-white fw-bold fs-30 my-3 pointer" onClick={(e) => {
                        store.dispatch(setNavigation(ROUTES.ABOUT))
                        setIsBurgerOpen(false)
                    }}>About</div>

                    <div className="text-white fw-bold fs-30 my-3 " >Read
                        <div className="pl-3 pt-3">
                            <div className="text-white fw-bold fs-30 py-3 pointer" onClick={(e) => {
                                store.dispatch(setNavigation(ROUTES.THE_MORSE_CODE))
                                setIsBurgerOpen(false)
                            }}>The Morse Code</div>

                            <div className="text-white fw-bold fs-30 py-3 pointer" onClick={(e) => {
                                store.dispatch(setNavigation(ROUTES.SAMUEL_MORSE))
                                setIsBurgerOpen(false)
                            }}>Samuel Morse</div>

                            <div className="text-white fw-bold fs-30 py-3 pointer" onClick={(e) => {
                                store.dispatch(setNavigation(ROUTES.THE_TELEGRAPH))
                                setIsBurgerOpen(false)
                            }}>The Telegraph</div>
                        </div>
                    </div>

                    <div className="text-white fw-bold fs-30 my-3 pointer" onClick={(e) => {
                        store.dispatch(setNavigation(ROUTES.CONTACT))
                        setIsBurgerOpen(false)
                    }}>Contact</div>

                </div>
            </div>
            <div className={` py-3 top-navigation ${toggleNavbar ? ' scrolled ' : ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-3 col-6">
                            <img src={logo} alt="Morse Code Academy" className="logo" />
                        </div>
                        <div className="col-lg-6 d-none d-lg-block">
                            <div className="navigation-items">
                                <div className="navigation-item pointer" onClick={(e) => {
                                    store.dispatch(setNavigation(ROUTES.HOME))
                                }}>
                                    <div className=" nav-label ">Home</div>
                                    <div className="line bg-white"></div>
                                </div>

                                <div onClick={(e) => {
                                    store.dispatch(setNavigation(ROUTES.ABOUT))
                                }} className="navigation-item pointer">
                                    <div className=" nav-label ">About</div>
                                    <div className="line bg-white"></div>
                                </div>


                                <div className="navigation-item pointer dropdown-wrapper" >
                                    <div className=" nav-label ">Read</div>
                                    <div className="line bg-white"></div>
                                    <div className="dropdown-container">
                                        <div className="navigation-item pointer" onClick={(e) => {
                                            store.dispatch(setNavigation(ROUTES.THE_MORSE_CODE))
                                        }}>
                                            <div className=" nav-label ">The Morse Code</div>
                                            <div className="line bg-white"></div>
                                        </div>
                                        <div className="navigation-item pointer" onClick={(e) => {
                                            store.dispatch(setNavigation(ROUTES.SAMUEL_MORSE))
                                        }}>
                                            <div className=" nav-label ">Samuel Morse</div>
                                            <div className="line bg-white"></div>
                                        </div>
                                        <div className="navigation-item pointer" onClick={(e) => {
                                            store.dispatch(setNavigation(ROUTES.THE_TELEGRAPH))
                                        }}>
                                            <div className=" nav-label ">The Telegraph</div>
                                            <div className="line bg-white"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="navigation-item pointer" onClick={(e) => {
                                    store.dispatch(setNavigation(ROUTES.CONTACT))
                                }}>
                                    <div className=" nav-label ">Contact</div>
                                    <div className="line bg-white"></div>
                                </div>

                            </div>
                        </div>

                        <div className="col-lg-4 col-6 text-right  d-block d-lg-none">
                            <div className={`burger-menu ml-auto ${isBurgerOpen ? ' open ' : ''}`} onClick={() => {
                                setIsBurgerOpen(p => !p)
                            }}>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}